import {
 AfterViewInit,
 ChangeDetectionStrategy,
 ChangeDetectorRef,
 Component,
 DestroyRef,
 ElementRef,
 EventEmitter,
 Inject,
 Input,
 OnInit,
 Output,
 PLATFORM_ID,
 QueryList,
 SkipSelf,
 ViewChildren,
 effect,
 inject,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import {
 ActivationWay,
 ForgetPasswordRequest,
 SendActivationCodeRequest,
 SendActivationCodeResponse,
} from '@core/models/DTOs/authentication.dto';
import { AuthService } from '@core/services/authentication/auth.service';
import { UserProfileRepository } from '@core/services/repositories/userProfile.repository';
import { NotificationService } from '@shared/components/notification/notification.service';
import { PersianToEnglishRegexPipe } from '@shared/pipes/persianToEnglish.pipe';
import { catchError } from 'rxjs';
import { LoginRegisterWrapperComponent } from '../login-register-wrapper.component';
import { isPlatformBrowser } from '@angular/common';
import { WINDOW } from '../login-register.module';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
 selector: 'iho-otp-stepper',
 templateUrl: './otp-stepper.component.html',
 styleUrls: ['./otp-stepper.component.scss'],
 // changeDetection: ChangeDetectionStrategy.OnPush,
 providers: [PersianToEnglishRegexPipe],
})
export class OtpStepperComponent implements OnInit, AfterViewInit {
 userData: any;
 expireTime = 0;
 @ViewChildren('otpInput') otpInputElements: QueryList<ElementRef>;
 myOTP: any;
 otpForm: FormGroup = new FormGroup({
  otpGroupInput: new FormControl(''),
 });
 ac: any;
 @Input() maxTime: number = 1;
 disabledBtn: boolean = true;
 @Input() phoneNumber: string = '';
 @Input() isForgetPass: boolean = false;
 otpDigits = new Array(6); // Array to represent 6 OTP digits
 otp: string[] = new Array(6); // Initialize OTP array
 @Output() status = new EventEmitter();
 codeErr: string = '';
 displayTimer: string = '';
 refreshOTP: boolean = false;
 errCode: boolean = false;
 showLoading: boolean = false;
 previousLastItemValue: string | null = null;

 destroyRef = inject(DestroyRef);
 @Output() emitModelVerify = new EventEmitter();
 @Input() responseActivationCode: any = {};
 //@Output() IdSendActivationCode = new EventEmitter<string>();
 @Input() resIdSendActivationCode: string = '';
 constructor(
  @SkipSelf() public AuthService: AuthService,
  private router: Router,
  public notif: NotificationService,
  private route: ActivatedRoute,
  public UserProfileSrvc: UserProfileRepository,
  private changeDetection: ChangeDetectorRef,
  public pipe: PersianToEnglishRegexPipe,
  public dialogRef: MatDialogRef<LoginRegisterWrapperComponent>,
  @Inject(WINDOW) private window: Window,
  @Inject(PLATFORM_ID) private platformId: Object
 ) {
  this.otpInputElements = new QueryList<ElementRef>();
  effect(() => {
   this.userData = this.AuthService.getUserData();

   if (this.userData()) {
    this.endLogin();
   }
  });
 }

 ngOnInit() {
  this.timer(this.maxTime);
  this.onGetCredentials();
 }
 endLogin() {
  this.dialogRef.close();
  this.notif.success('ورود کاربر', '   با موفقیت انجام شد');
  this.router.navigate([], { relativeTo: this.route, queryParams: {} });
  this.changeDetection.detectChanges();
 }
 onInput(event: any, index: number) {
  this.changeDetection.markForCheck();

  // Ensure the input is a single digit number
  let digit = event.target.value;
  digit = this.persianToEnglishRegex(digit);
  if (/[0-9]|\./.test(digit) && digit.length === 1) {
   this.otp[index] = digit;

   // Move to the next input field if a digit is entered
   if (index < this.otpDigits.length - 1) {
    this.disabledBtn = true;
    const nextInput = this.otpInputElements.toArray()[index + 1];
    if (nextInput) {
     nextInput.nativeElement.focus();
    }
   }
  } else if (digit == '') {
   this.otp[index] = '';
   this.errCode = false;
   if (index > 0) {
    this.otp[index] = '';
    this.disabledBtn = true;
    const prevInput = this.otpInputElements.toArray()[index - 1];
    if (prevInput) {
     prevInput.nativeElement.focus();
     this.errCode = false;
    }
   }
  } else {
   // Clear the input if it's not a valid digit
   this.errCode = false;
   this.otp[index] = '';
   this.disabledBtn = true;
  }
  // check otp check

  if (digit != '' && this.otpDigits.length == index + 1) {
   this.disabledBtn = false;
   if (this.otp[index] != '' && this.previousLastItemValue != this.otp[index]) {
    this.previousLastItemValue = this.otp[index];
    this.changeDetection.markForCheck();

    this.emitStep('step-new-pass');
   }
  }
 }

 timer(seconds: number = 60) {
  this.otp.forEach((item, index) => {
   this.otp[index] = '';
  });

  let textSec: any = '0';
  let statSec: number = seconds;

  const timer = setInterval(() => {
   seconds--;
   if (statSec != 0) {
    statSec--;
   } else {
    statSec = 59;
   }

   if (statSec < 10) {
    textSec = '0' + statSec;
   } else {
    textSec = statSec;
   }

   const displayMinutes = Math.floor(seconds / 60);
   const displaySeconds = seconds % 60;

   const prefixMin = displayMinutes < 10 ? '0' : '';
   const prefixSec = displaySeconds < 10 ? '0' : '';

   this.displayTimer = `${prefixMin}${displayMinutes}:${prefixSec}${displaySeconds}`;

   if (seconds == 0) {
    this.refreshOTP = true;
    clearInterval(timer);
   }
   this.changeDetection.markForCheck();
  }, 1000);
 }

 ngAfterViewInit() {
  this.otpInputElements.toArray()[0].nativeElement.focus();
 }
 onInputPaste(event: ClipboardEvent) {
  (event.target as any).blur();
  if (isPlatformBrowser(this.platformId)) {
   let clipboardData = event.clipboardData || (<any>this.window).clipboardData;
   let pastedText = clipboardData.getData('text');

   const digit = pastedText.split('');

   digit.forEach((item: any, index: any) => {
    this.otp[index] = item;
   });
   this.disabledBtn = false;
   this.emitStep('step-new-pass');
  }
 }
 emitStep(type: string) {
  if (this.isForgetPass && type == 'step-register') {
   this.status.emit('step-forget-pass');
  } else if (!this.isForgetPass && type == 'step-register') {
   this.status.emit('step-register');
  } else {
   let modelVerify = {
    Id: this.responseActivationCode.Id,
    VerifyCode: (this.otp.toString() as any).replaceAll(',', ''),
    ActivationWay: 0,
   };
   this.emitModelVerify.emit(modelVerify);
   this.showLoading = true;

   this.AuthService.VerifyActivationCode(modelVerify)
    .pipe(
     // active code error
     takeUntilDestroyed(this.destroyRef),
     catchError((err) => {
      this.showLoading = false;
      this.errCode = true;
       if (err.status === 400 && err.error && err.error.Message) {
         this.codeErr = err.error.Message;
       } else {
         this.codeErr = 'Unknown error';
       }

      this.changeDetection.markForCheck();

      throw 'error in source. Details: ' + err;
     })
    )
    // is active code true
    .subscribe((response) => {
     this.showLoading = false;
     //  this.changeDetection.markForCheck();
     this.changeDetection.detectChanges();

      if (response.result == true) {
        if (response.jwtToken){
          localStorage.setItem('AccessToken', response?.jwtToken);
          document.cookie = `ihoLoggedIn=1; path=/; max-age=${60 * 60 * 24 * 30}`;
        }
      if (!this.isForgetPass) {
        // 1 is register
       if (this.responseActivationCode.ActivationWay == 1) {
         this.AuthService.userProfile();
       } else if (this.responseActivationCode.ActivationWay == 2) {
        this.status.emit('step-new-pass');
       // 0 is login
       } else if (this.responseActivationCode.ActivationWay == 0) {
        //login
        this.AuthService.userProfile();
       }
      } else {
       // forget password
       this.status.emit('step-new-pass');
      }
     } else {
      this.errCode = true;
     }
    });
  }
 }
 timerAgain() {
  this.errCode = false;
  this.refreshOTP = false;
  this.resendOTP();
 }

 resendOTP() {
  let modelSendActivationCode: SendActivationCodeRequest = {
   Email: '',
   Mobile: this.phoneNumber,
   ActivationWay: ActivationWay.Register,
   Token: '',
  };
  this.AuthService.SendActivationCode(modelSendActivationCode)
   .pipe(takeUntilDestroyed(this.destroyRef))
   .subscribe((res: SendActivationCodeResponse) => {
    this.responseActivationCode = res;
    this.expireTime = res.ActivationCodeExpireDate;
    this.timer(this.expireTime);
    this.onGetCredentials();
   });
 }

 changeAbort(ev: any) {}
 async onGetCredentials() {
  if (isPlatformBrowser(this.platformId)) {
   if ('OTPCredential' in this.window) {
    const ac = new AbortController();
    ac.abort();

    let reqObj = {
     otp: { transport: ['sms'] },
     signal: ac.signal,
    };

    navigator.credentials
     .get(reqObj)
     .then((otp: any) => {
      if (otp) {
       if (otp && otp.code) {
        this.myOTP = otp.code;
        const digit = this.myOTP.split('');

        digit.forEach((item: any, index: any) => {
         this.otp[index] = item;
        });
        this.disabledBtn = false;
        this.emitStep('step-new-pass');
       }
      }
     })
     .catch((err) => {});
   } else {
   }
  }
 }

 persianToEnglishRegex(value: any) {
  return this.pipe.transform(value);
 }
}
